export default __webpack_public_path__ + "static/media/Twitter.1a1c0729.svg";